<template>
    <div class='index'>
		 <Bar />
        <router-view></router-view>
		 <Place />

    </div>
</template>
<script>
import Bar from '@/components/bar/bar'
import Place from '@/components/place/place'

export default {
    components:{
        Bar,Place
    }
}
</script>